import TrendButton from "./TrendButton";
import { useModuleContext, inferUnit, extractNumeric } from "../lib/moduleCtx";

export default function Panel({
  title, subtitle, icon, children, action, testid,
  // Optional overrides for Trend Analyzer
  widgetId, module, unit, current,
  // Set false to hide the trend button on this specific panel
  showTrend = true,
}) {
  const autoModule = useModuleContext();
  const resolvedModule = module || autoModule;
  const resolvedUnit = unit || inferUnit(current);
  const resolvedWidgetId = widgetId || testid;
  const num = typeof current === "number" ? current : extractNumeric(current);

  return (
    <div className="cv-panel" data-testid={testid}>
      <div className="flex items-center gap-[10px] mb-3">
        {icon && (
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ background: "var(--cv-sand)" }}
          >
            {icon}
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div
            className="font-bold small-caps text-[16px]"
            style={{ color: "var(--cv-charcoal)" }}
          >
            {title}
          </div>
          {subtitle && (
            <div className="text-[12.5px] mt-0.5" style={{ color: "var(--cv-charcoal-soft)" }}>
              {subtitle}
            </div>
          )}
        </div>
        {showTrend && resolvedWidgetId && (
          <TrendButton
            widgetId={resolvedWidgetId}
            label={title}
            module={resolvedModule}
            unit={resolvedUnit}
            current={num}
            testid={testid ? `${testid}-view-trend` : undefined}
          />
        )}
        {action}
      </div>
      {children}
    </div>
  );
}
